export default __webpack_public_path__ + "c12cc8e898b7a5d2d4c14eec45277dde.ttf";